import { differenceInSeconds, format } from "date-fns";
import { EMPTY } from "@/lib/formatters";

const toDate = (v: string | Date | null | undefined) => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "12s ago", "5m ago", "3h ago", "4d ago", "in 2h" */
export function formatRelative(v: string | Date | null | undefined, now = new Date()): string {
  const d = toDate(v);
  if (!d) return EMPTY;
  const s = differenceInSeconds(now, d);
  const a = Math.abs(s);
  const unit =
    a < 60
      ? `${a}s`
      : a < 3600
        ? `${Math.floor(a / 60)}m`
        : a < 86400
          ? `${Math.floor(a / 3600)}h`
          : a < 86400 * 60
            ? `${Math.floor(a / 86400)}d`
            : `${Math.floor(a / (86400 * 30))}mo`;
  if (a < 5) return "just now";
  return s >= 0 ? `${unit} ago` : `in ${unit}`;
}

/** "2026-09-29 14:02:11" — unambiguous for logs and audits (local time). */
export const formatDateTime = (v: string | Date | null | undefined) => {
  const d = toDate(v);
  return d ? format(d, "yyyy-MM-dd HH:mm:ss") : EMPTY;
};
export const formatDate = (v: string | Date | null | undefined) => {
  const d = toDate(v);
  return d ? format(d, "yyyy-MM-dd") : EMPTY;
};
export const formatTime = (v: string | Date | null | undefined) => {
  const d = toDate(v);
  return d ? format(d, "HH:mm:ss") : EMPTY;
};
export const formatShortDateTime = (v: string | Date | null | undefined) => {
  const d = toDate(v);
  return d ? format(d, "MMM d, HH:mm") : EMPTY;
};

/** Milliseconds between two timestamps, or null. */
export const between = (a: string | null | undefined, b: string | null | undefined) => {
  const x = toDate(a);
  const y = toDate(b);
  return x && y ? y.getTime() - x.getTime() : null;
};
